module.exports = __webpack_public_path__ + "img/antes_despues_298.20174e39.png";